import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { SettingDefinition } from "../models/SettingDefinition";
import { SettingDefinitionProps } from "../models/SettingDefinition";

interface IUseSettingDefinition {
  id: string | number;
}

interface IUseSettingDefinitionReturn {
  fetch: UseFetchResult<SettingDefinitionProps>;
  data: SettingDefinition | null;
}

export const useSettingDefinition = ({
  id,
}: IUseSettingDefinition): IUseSettingDefinitionReturn => {
  const fetch = useFetch<SettingDefinitionProps>(
    `/api/setting-definitions/${id}`,
    {
      initialData: {},
      skipInitialFetch: !id,
    }
  );

  const data = fetch.data ? new SettingDefinition(fetch.data) : null;

  return {
    fetch,
    data,
  };
};
